import { getCSSVar } from "shared/lib/utils"

if (typeof window !== "undefined" && typeof window.globalHighchartsOptions === "undefined") {
  window.globalHighchartsOptions = {
    lang: {
      thousandsSep: ",",
    },
    // Highcharts 13's default theme resolves colors with CSS light-dark() against
    // each container's color-scheme, so charts turn dark under the OS's
    // prefers-color-scheme: dark. Web has no dark mode, so force light: this sets
    // color-scheme: light inline on every container.
    palette: {
      colorScheme: "light",
    },
    chart: {
      style: {
        fontFamily: getCSSVar("base-font-family"),
      },
    },
  }
}
